import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Partial from "../Partial/index.js";
const unsafeFromJust = reason => mb => {
  if (mb.tag === "Nothing") { return Partial._crashWith("Error: fromJust " + reason)(); }
  if (mb.tag === "Just") { return mb._1; }
  $runtime.fail();
};
const maybeModify = f => x => {
  const $0 = f(x);
  if ($0.tag === "Nothing") { return x; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
};
const maybeBool = p => x => {
  if (p(x)) { return Data$dMaybe.$Maybe("Just", x); }
  return Data$dMaybe.Nothing;
};
const emptyToNothing = dictEq => dictMonoid => value => {
  if (dictEq.eq(value)(dictMonoid.mempty)) { return Data$dMaybe.Nothing; }
  return Data$dMaybe.$Maybe("Just", value);
};
export {emptyToNothing, maybeBool, maybeModify, unsafeFromJust};
